/// <reference types="vite/client" />

// Resolved by the consuming app's Vite build, so every file is fingerprinted.
const files = import.meta.glob<string>("../assets/*.svg", { query: "?url", import: "default", eager: true });

export const brandAssets: Record<string, string> = Object.fromEntries(
  Object.entries(files).map(([path, url]) => [path.slice(path.lastIndexOf("/") + 1), url]),
);

export function brandAsset(file: string): string {
  const url = brandAssets[file];
  if (!url) throw new Error(`Unknown brand asset: ${file}`);
  return url;
}
